import React from 'react';
import PropTypes from 'prop-types';

import FullPageQuizQuestion, {
  FULL_PAGE_QUIZ_QUESTION_VARIANTS
} from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import OptionGroup from 'dpl/quiz/option_group/components/OptionGroup';
import OptionGroupOption from 'dpl/quiz/option_group/components/OptionGroupOption';
import { OPTION_GROUP_VARIANTS } from 'dpl/quiz/option_group/utils/constants';

const INPUT_NAME = 'current_pets_types';

const options = [
  {
    icon: 'pet-none',
    title: 'No pets',
    value: 'none'
  },
  {
    icon: 'pet-dogs',
    title: 'Dog(s)',
    value: 'dogs'
  },
  {
    icon: 'pet-cats',
    title: 'Cat(s)',
    value: 'cats'
  },
  {
    icon: 'pet-birds',
    title: 'Other',
    value: 'other'
  }
];

export default function QuizCurrentPetsTypesQuestion({
  formState,
  handleNextClick,
  onChange,
  isValid
}) {
  function onSelectOption(e) {
    const { value, checked } = e.target;

    if (checked && value === 'none') {
      onChange(INPUT_NAME, ['none'], handleNextClick);
      return;
    }

    const newValue = new Set(formState[INPUT_NAME] || []);

    if (checked) {
      newValue.add(value);
      if (newValue.has('none')) {
        newValue.delete('none');
      }
    } else {
      newValue.delete(value);
    }

    onChange(INPUT_NAME, [...newValue]);
  }

  return (
    <div className="AdoptionApplicationQuizCurrentPetsTypeQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        isValid={isValid}
        title="Do you currently have any pets?"
        subtitle="Select all that apply."
        variant={FULL_PAGE_QUIZ_QUESTION_VARIANTS.WIDE}
      >
        <OptionGroup variant={OPTION_GROUP_VARIANTS.ICON}>
          {options.map(o => (
            <OptionGroupOption
              type="checkbox"
              key={o.value}
              inputName={INPUT_NAME}
              icon={o.icon}
              title={o.title}
              value={o.value}
              onSelect={onSelectOption}
              isSelected={formState[INPUT_NAME].includes(o.value)}
            />
          ))}
        </OptionGroup>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizCurrentPetsTypesQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
};
